import { Field } from "@kanda-libs/ks-component-ts";
import { Button, Text } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import { LEVEL_OPTIONS } from "./constants";

export interface FlagFormProps {
  isLoading?: boolean;
}

const FlagForm: FunctionComponent<FlagFormProps> = function ({ isLoading }) {
  return (
    <div className="w-120">
      <Text className="text-20-12-em text-neutral-600" text="Create new flag" />
      <Field.Select name="level" label="Level" options={LEVEL_OPTIONS} />
      <Field.Input name="remark" label="Remark" />
      <Button.Text
        id="create-flag-staff-button"
        submit
        label="Create"
        isLoading={isLoading}
      />
    </div>
  );
};

export default FlagForm;
